// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qL2nM68aHMwKNApXnl_D{flex-direction:column;flex-grow:1;width:620px;margin:0 auto;display:flex}@media (min-width:992px){.qL2nM68aHMwKNApXnl_D{width:760px}}.qL2nM68aHMwKNApXnl_D header{justify-content:space-between;align-items:center;padding:68px 20px 0;display:flex}.SssuRMn6qewl_khjH8SS{border-color:var(--border-neutral-default);border-radius:12px}.dHSyxSzDSgCVkOtu2nds{flex-direction:column;flex-grow:1;gap:4px;margin-right:20px;display:flex}.NmyWle0ffsDYwmnnnXgx{align-items:center;gap:4px;display:flex}.f5aBeKodLw0tbJG859wW{gap:8px;display:flex}.pcl6oPyjKlU0tgxWi_9w{text-decoration:none}.IPaJZNsnpLciJQGSoFzt{padding:16px 20px 0}.he5Ded2zS4ABDwKKYzof{flex-direction:column;gap:16px;height:100%;padding:32px 11px 0 15px;display:flex}.rkCu1lJTdopV8POUbKu5{height:32px}.uxD9spwod83QfStzFW0R{display:flex}._FOTdwIp349STIFP50iS{justify-content:center;display:flex}.q8PhL067v4YIDxSjGdi2{margin-left:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `qL2nM68aHMwKNApXnl_D`,
	"headerLogo": `SssuRMn6qewl_khjH8SS`,
	"integrationDetailsHeader": `dHSyxSzDSgCVkOtu2nds`,
	"title": `NmyWle0ffsDYwmnnnXgx`,
	"actions": `f5aBeKodLw0tbJG859wW`,
	"docsButton": `pcl6oPyjKlU0tgxWi_9w`,
	"alerts": `IPaJZNsnpLciJQGSoFzt`,
	"navBar": `he5Ded2zS4ABDwKKYzof`,
	"navBarHolder": `rkCu1lJTdopV8POUbKu5`,
	"navBarTabs": `uxD9spwod83QfStzFW0R`,
	"count": `_FOTdwIp349STIFP50iS`,
	"icon": `q8PhL067v4YIDxSjGdi2`
};
export default ___CSS_LOADER_EXPORT___;
